// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--MMpYJ";
export var rowWrapper = "HeroSection-module--rowWrapper--14QhK";
export var list = "HeroSection-module--list--9bN0X";
export var listBottom = "HeroSection-module--listBottom--th5M8";
export var number = "HeroSection-module--number--vN3fk";
export var deliveredBy = "HeroSection-module--deliveredBy--D5RbW";
export var educationItem = "HeroSection-module--educationItem--ACYlT";